import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import {
  List,
  ListItem,
  withStyles,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core'
import {
  Flare,
  People,
  CameraAlt,
  ThumbDown,
  MoveToInbox,
  FolderSpecial,
  PermContactCalendar,

  FlareOutlined,
  PeopleOutlined,
  CameraAltOutlined,
  ThumbDownOutlined,
  MoveToInboxOutlined,
  FolderSpecialOutlined,
  PermContactCalendarOutlined,
} from '@material-ui/icons'

import { DRAWER_WIDTH, ROUTES, IS_DEV } from '../constant'


const menu = [
  {
    fill: '#ffa502',
    title: 'Waitlist',
    icon: MoveToInbox,
    pathname: ROUTES.HOME,
    iconOutlined: MoveToInboxOutlined,
  },
  {
    fill: '#ff4757',
    title: 'Rejected',
    icon: ThumbDown,
    pathname: ROUTES.REJECTED,
    iconOutlined: ThumbDownOutlined,
  },
  {
    icon: People,
    title: 'Models',
    fill: '#a55eea',
    pathname: ROUTES.MODELS,
    iconOutlined: PeopleOutlined,
  },
  {
    fill: '#2f3542',
    icon: CameraAlt,
    title: 'Photographers',
    pathname: ROUTES.PHOTOGRAPHERS,
    iconOutlined: CameraAltOutlined,
  },
  {
    fill: '#e1b12c',
    title: 'Clients',
    pathname: ROUTES.CLIENTS,
    icon: PermContactCalendar,
    iconOutlined: PermContactCalendarOutlined,
  },
  {
    fill: '#2ed573',
    title: 'Castings',
    icon: FolderSpecial,
    pathname: ROUTES.CASTINGS,
    iconOutlined: FolderSpecialOutlined,
  },
]

if (IS_DEV) {
  menu.push({
    icon: Flare,
    fill: '#1e90ff',
    title: 'Magic helpers',
    pathname: ROUTES.MAGIC,
    iconOutlined: FlareOutlined,
  })
}


const styles = theme => ({
  root: {
    width: 0,
    flexShrink: 0,
    overflow: 'hidden',
    background: 'white',
    transition: 'width .2s ease-in-out',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.25)',
  },
  opened: {
    width: DRAWER_WIDTH,
  },
  icon: {
    opacity: 0.6,
  },
  list: {
    paddingTop: 0,
    color: theme.palette.common.black,
  },
})


const Drawer = ({
  opened,
  classes,
  pathname,
  className,
}) => (
  <div
    className={classNames(classes.root, {
      [classes.opened]: opened,
    }, className)}
  >
    <List className={classes.list}>
      {menu.map((item) => {
        const selected = item.pathname === ROUTES.HOME ? item.pathname === pathname : pathname.includes(item.pathname)
        const iconProps = {
          style: { fill: item.fill },
          className: selected ? classes.iconSelected : classes.icon,
        }

        return (
          <ListItem
            button
            component={Link}
            to={item.pathname}
            key={item.pathname}
            selected={selected}
          >
            <ListItemIcon>{selected ? <item.icon {...iconProps} /> : <item.iconOutlined {...iconProps} />}</ListItemIcon>
            <ListItemText style={{ color: selected ? item.fill : 'inherit' }}>
              {item.title}
            </ListItemText>
          </ListItem>
        )
      })}
    </List>
  </div>
)


Drawer.propTypes = {
  opened: PropTypes.bool,
  pathname: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Drawer)
